import classnames from 'classnames'
import PropTypes from 'prop-types'

import DigitalWorldIcon from '../../../../../shared_assets/category_icons/svg/DigitalWorldIcon.jsx'
import FamilyAndLovedOnesIcon from '../../../../../shared_assets/category_icons/svg/FamilyAndLovedOnesIcon.jsx'
import FinancialIcon from '../../../../../shared_assets/category_icons/svg/FinancialIcon.jsx'
import LegalIcon from '../../../../../shared_assets/category_icons/svg/LegalIcon.jsx'
import MedicalIcon from '../../../../../shared_assets/category_icons/svg/MedicalIcon.jsx'
import LifeAndLegacyIcon from '../../../../../shared_assets/category_icons/svg/LifeAndLegacyIcon.jsx'
import OldAgeIcon from '../../../../../shared_assets/category_icons/svg/OldAgeIcon'
import PersonalInfoAndIdsIcon from '../../../../../shared_assets/category_icons/svg/PersonalInfoAndIdsIcon.jsx'
import PropertyIcon from '../../../../../shared_assets/category_icons/svg/PropertyIcon.jsx'

import './categoryHeaderIcon.scss'

const CATEGORY_ICONS = {
  'ids and personal info': PersonalInfoAndIdsIcon,
  'my life': PersonalInfoAndIdsIcon,
  digital: DigitalWorldIcon,
  'family and loved ones': FamilyAndLovedOnesIcon,
  financial: FinancialIcon,
  legal: LegalIcon,
  health: MedicalIcon,
  aging: OldAgeIcon,
  'home and property': PropertyIcon,
  'life and legacy': LifeAndLegacyIcon
}

// Need to change the `prop` `categoryName` to lower-case as we manipulate the
// URL slug for categories from the `/corp_max/Category.react.js` component. --KTW
const CategoryHeaderIcon = ({categoryName, className}) => {
  const IconComponent = CATEGORY_ICONS[categoryName.toLowerCase()]

  if (!IconComponent) return null

  return (
    <IconComponent
      aria-label={`${categoryName} category icon`}
      className={classnames('category-header-icon', className)}
      role='img'
    />
  )
}

CategoryHeaderIcon.propTypes = {
  categoryName: PropTypes.string,
  className: PropTypes.string
}

export default CategoryHeaderIcon
